module.exports = __webpack_public_path__ + "static/card-commissioner-weissman-a50c5419d5738d98fdee5c13d873c931.jpg";